// extracted by mini-css-extract-plugin
module.exports = {"badge":"zfTqKm","accent":"jz0YqC","green":"kA0C2a","light":"AT5fte","sponsor":"c8155XS","medium":"AwTceG","small":"c4_Kiwo"};